/* Luky Parfums — theme script (talks to the real Shopify cart, not localStorage) */

// Burger menu
var burger = document.querySelector('.burger');
var navLinks = document.querySelector('.nav-links');
if (burger && navLinks) {
  burger.addEventListener('click', function () { navLinks.classList.toggle('open'); });
}

// Hero gallery carousel
(function () {
  var gallery = document.getElementById('hero-gallery');
  if (!gallery) return;
  var track = document.getElementById('gallery-track');
  var thumbsWrap = document.getElementById('gallery-thumbs');
  var prevBtn = gallery.querySelector('.gallery-prev');
  var nextBtn = gallery.querySelector('.gallery-next');
  var slides = track.querySelectorAll('.gallery-slide');
  var count = slides.length;
  var i = 0, timer;
  if (count <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    if (thumbsWrap) thumbsWrap.style.display = 'none';
    return;
  }
  var thumbs = thumbsWrap.querySelectorAll('.gallery-thumb');
  function goTo(idx) {
    i = (idx + count) % count;
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    thumbs.forEach(function (th, ti) { th.classList.toggle('active', ti === i); });
  }
  function next() { goTo(i + 1); }
  function prev() { goTo(i - 1); }
  function resetTimer() { clearInterval(timer); timer = setInterval(next, 4500); }
  thumbs.forEach(function (t, ti) { t.addEventListener('click', function () { goTo(ti); resetTimer(); }); });
  if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetTimer(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetTimer(); });
  resetTimer();
})();

/* ============================================================
   Cart badge — reads the real Shopify cart via /cart.js
   ============================================================ */
function lukyRefreshCartBadge() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('#cart-count, .cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(function () {});
}
lukyRefreshCartBadge();

/* ============================================================
   Cart drawer (slide-in from the right) — opens after a product
   is added to the cart so customers can keep browsing instead
   of being sent straight to the full cart page. Also opens when
   clicking the cart icon in the header (instead of navigating
   straight to the /cart page).
   ============================================================ */
(function () {
  var overlay = document.getElementById('cart-drawer-overlay');
  var drawer = document.getElementById('cart-drawer');
  if (!drawer || !overlay) return;

  var closeBtn = document.getElementById('cart-drawer-close');
  var continueBtn = document.getElementById('cart-drawer-continue');
  var bodyEl = document.getElementById('cart-drawer-body');
  var footerEl = document.getElementById('cart-drawer-footer');
  var totalEl = document.getElementById('cart-drawer-total');
  var shippingWrapEl = document.getElementById('cart-drawer-shipping-wrap');
  var shippingEl = document.getElementById('cart-drawer-shipping');
  var shippingBarEl = document.getElementById('cart-drawer-shipping-bar');

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmtMoney(cents) {
    return 'S/ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateShippingProgress(cart) {
    if (!shippingEl || !footerEl) return;
    var thresholdSoles = parseFloat(footerEl.getAttribute('data-free-shipping-threshold'));
    if (isNaN(thresholdSoles)) thresholdSoles = 150;
    var thresholdCents = Math.round(thresholdSoles * 100);
    var missing = thresholdCents - cart.total_price;
    var pct = thresholdCents > 0 ? Math.max(0, Math.min(100, (cart.total_price / thresholdCents) * 100)) : 100;
    if (shippingBarEl) shippingBarEl.style.width = pct + '%';
    var reached = missing <= 0;
    if (!reached) {
      var missingText = shippingEl.getAttribute('data-missing-text') || 'Te faltan [amount] para envío gratis';
      shippingEl.textContent = missingText.replace('[amount]', fmtMoney(missing));
    } else {
      var reachedText = shippingEl.getAttribute('data-reached-text') || '¡Tu pedido ya califica para envío gratis!';
      shippingEl.textContent = reachedText;
    }
    shippingEl.classList.toggle('reached', reached);
    if (shippingBarEl) shippingBarEl.classList.toggle('reached', reached);
    if (shippingWrapEl) shippingWrapEl.classList.toggle('reached', reached);
  }

  function render(cart) {
    if (!bodyEl) return;
    if (!cart.items.length) {
      var emptyText = bodyEl.getAttribute('data-empty-text') || 'Tu carrito está vacío por ahora.';
      bodyEl.innerHTML = '<div class="cd-empty"><div style="font-size:40px;margin-bottom:12px;">🛒</div><p>' + escapeHtml(emptyText) + '</p></div>';
      if (footerEl) footerEl.style.display = 'none';
      if (shippingEl) shippingEl.textContent = '';
      if (shippingBarEl) shippingBarEl.style.width = '0%';
      return;
    }
    if (footerEl) footerEl.style.display = '';
    bodyEl.innerHTML = cart.items.map(function (item) {
      var size = item.variant_options && item.variant_options[0] ? item.variant_options[0] : '';
      var qtyLabel = item.variant_options && item.variant_options[1] ? item.variant_options[1] : '';
      var imgSrc = item.image ? (item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=170') : '';
      var unitPrice = item.final_line_price / item.quantity;
      return (
        '<div class="cd-item">' +
          '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '">' +
          '<div class="cdi-info">' +
            '<b>' + escapeHtml(item.product_title) + '</b>' +
            '<div class="cdi-price">' + fmtMoney(unitPrice) + ' c/u</div>' +
            '<div class="cdi-size">Tamaño: ' + escapeHtml(size) + (qtyLabel ? ' · Cantidad: ' + escapeHtml(qtyLabel) : '') + '</div>' +
            '<div class="ci-controls">' +
              '<div class="ci-qty">' +
                '<button type="button" data-cd-dec data-key="' + item.key + '" data-current="' + item.quantity + '">−</button>' +
                '<input type="text" readonly value="' + item.quantity + '">' +
                '<button type="button" data-cd-inc data-key="' + item.key + '" data-current="' + item.quantity + '">+</button>' +
              '</div>' +
              '<button type="button" class="cdi-remove" data-cd-remove data-key="' + item.key + '" aria-label="Eliminar" title="Eliminar">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-total">' + fmtMoney(item.final_line_price) + '</div>' +
        '</div>'
      );
    }).join('');
    if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);
    updateShippingProgress(cart);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function refresh() {
    fetchCart().then(render).catch(function () {});
  }

  function open() {
    refresh();
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function changeLine(key, qty) {
    var updates = {};
    updates[key] = qty;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        lukyRefreshCartBadge();
      });
  }

  if (bodyEl) {
    bodyEl.addEventListener('click', function (e) {
      var decBtn = e.target.closest('[data-cd-dec]');
      var incBtn = e.target.closest('[data-cd-inc]');
      var remBtn = e.target.closest('[data-cd-remove]');
      if (decBtn) {
        var qd = parseInt(decBtn.getAttribute('data-current'), 10) - 1;
        changeLine(decBtn.getAttribute('data-key'), qd);
      } else if (incBtn) {
        var qi = parseInt(incBtn.getAttribute('data-current'), 10) + 1;
        changeLine(incBtn.getAttribute('data-key'), qi);
      } else if (remBtn) {
        changeLine(remBtn.getAttribute('data-key'), 0);
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (continueBtn) continueBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  var navCartLink = document.getElementById('nav-cart-link');
  if (navCartLink) {
    navCartLink.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  }

  window.lukyOpenCartDrawer = open;
  window.lukyCloseCartDrawer = close;
  window.lukyRefreshCartDrawer = refresh;
})();

/* ============================================================
   Portada — "X personas están viendo esto" urgency counter.
   Simulado (no viene de analítica real de visitas): arranca en
   un valor aleatorio (rango editable desde el editor de temas)
   y se queda fijo, cambiando a otro valor aleatorio solo cada
   5 minutos (no cada pocos segundos).
   ============================================================ */
(function () {
  var wrap = document.getElementById('pdp-viewers');
  var countEl = document.getElementById('pdp-viewers-count');
  if (!wrap || !countEl) return;

  var min = parseInt(wrap.getAttribute('data-viewers-min'), 10);
  var max = parseInt(wrap.getAttribute('data-viewers-max'), 10);
  if (isNaN(min)) min = 9;
  if (isNaN(max) || max < min) max = min + 25;

  function rand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
  function setCount() { countEl.textContent = rand(min, max); }

  setCount();
  setInterval(setCount, 5 * 60 * 1000);
})();

/* ============================================================
   Product page — Tamaño / Cantidad variant picker
   Reads the product's real variants (json embedded by Liquid)
   and drives a real <select name="id"> inside the product form.
   Single-variant products (e.g. Gissah, sold only as a full
   200 ml bottle) skip the Cantidad row and, when there's only
   one size, the Tamaño row too.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-product-picker]');
  if (!root) return;
  var variants = JSON.parse(root.getAttribute('data-variants'));
  var select = root.querySelector('select[name="id"]');
  var sizeRow = root.querySelector('.pdp-size-row');
  var sizeTabs = root.querySelectorAll('.size-tab');
  var qtyRow = root.querySelector('.pdp-qty-row');
  var qtyWrap = root.querySelector('.pdp-qty-row .pdp-pills');
  var priceEl = document.getElementById('pdp-price');
  var addBtn = document.getElementById('add-to-cart-btn');
  var infoRow = document.getElementById('pdp-stock-row');

  var hasQtyOption = variants.some(function (v) { return v.option2; });
  if (!hasQtyOption && qtyRow) qtyRow.style.display = 'none';
  if (sizeTabs.length <= 1 && sizeRow) sizeRow.style.display = 'none';

  var state = { size: sizeTabs.length ? sizeTabs[0].getAttribute('data-size') : null, qty: null };

  function fmt(n) {
    return (Math.round(n * 100) / 100).toString().replace('.', ',');
  }

  function variantsForSize(size) {
    return variants.filter(function (v) { return v.option1 === size; });
  }

  function renderQty() {
    if (!hasQtyOption || !qtyWrap) { update(); return; }
    var opts = variantsForSize(state.size);
    if (!state.qty || !opts.some(function (v) { return v.option2 === state.qty; })) {
      state.qty = opts.length ? opts[0].option2 : null;
    }
    qtyWrap.innerHTML = opts.map(function (v) {
      var active = v.option2 === state.qty ? ' active' : '';
      var unavailable = !v.available ? ' unavailable' : '';
      return '<div class="pdp-pill' + active + unavailable + '" data-qty="' + v.option2 + '">' + v.option2 + '<br><small>S/ ' + fmt(v.price) + '</small></div>';
    }).join('');
    qtyWrap.querySelectorAll('.pdp-pill').forEach(function (el) {
      el.addEventListener('click', function () {
        state.qty = el.getAttribute('data-qty');
        update();
      });
    });
    update();
  }

  function currentVariant() {
    if (!hasQtyOption) {
      return variants.find(function (v) { return v.option1 === state.size; });
    }
    return variants.find(function (v) { return v.option1 === state.size && v.option2 === state.qty; });
  }

  function update() {
    var v = currentVariant();
    if (!v) return;
    if (priceEl) priceEl.textContent = 'S/ ' + fmt(v.price);
    if (select) select.value = v.id;
    if (hasQtyOption && qtyWrap) {
      qtyWrap.querySelectorAll('.pdp-pill').forEach(function (el) {
        el.classList.toggle('active', el.getAttribute('data-qty') === state.qty);
      });
    }
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.getAttribute('data-add-label') || '🛒 Agregar al carrito de compras' : addBtn.getAttribute('data-sold-out-label') || 'Agotado';
    }
    if (infoRow) {
      infoRow.innerHTML = v.available
        ? '<span class="dot-green"></span> ' + (infoRow.getAttribute('data-stock-text') || 'Pocas unidades en stock')
        : (infoRow.getAttribute('data-out-of-stock-text') || 'Sin stock en esta presentación');
    }
  }

  sizeTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      sizeTabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      state.size = tab.getAttribute('data-size');
      state.qty = null;
      renderQty();
    });
  });

  renderQty();

  // Product gallery thumbnails
  var gal = document.querySelector('.pdp-gallery');
  if (gal) {
    var mainImg = gal.querySelector('.pdp-main img');
    var thumbs = gal.querySelectorAll('.pdp-thumbs img');
    var idx = 0;
    function show(n) {
      if (!thumbs.length) return;
      idx = (n + thumbs.length) % thumbs.length;
      mainImg.src = thumbs[idx].getAttribute('data-full') || thumbs[idx].src;
      thumbs.forEach(function (t, ti) { t.classList.toggle('active', ti === idx); });
    }
    thumbs.forEach(function (t, ti) { t.addEventListener('click', function () { show(ti); }); });
    var prevBtn = gal.querySelector('.pdp-nav-btn.prev');
    var nextBtn = gal.querySelector('.pdp-nav-btn.next');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); });
  }

  // Add to cart via /cart/add.js, then open the cart drawer so the
  // customer can keep browsing instead of leaving the product page.
  var form = root.querySelector('form[action^="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addLabel = addBtn ? (addBtn.getAttribute('data-add-label') || '🛒 Agregar al carrito de compras') : '';
      var addedLabel = addBtn ? (addBtn.getAttribute('data-added-label') || '✓ Agregado al carrito') : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-adding-label') || 'Agregando…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: select.value, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          lukyRefreshCartBadge();
          if (addBtn) { addBtn.textContent = addedLabel; addBtn.classList.add('added'); }
          if (window.lukyOpenCartDrawer) { window.lukyOpenCartDrawer(); }
          setTimeout(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = addLabel; addBtn.classList.remove('added'); }
          }, 1600);
        })
        .catch(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = addLabel; }
        });
    });
  }
})();

/* ============================================================
   Cart page — quantity steppers wired to /cart/update.js
   (uses the line item's unique key, not its numeric index —
   /cart/change.js by line index was rejected by a volume
   discount app's backend once a discount applied to the line,
   so we address lines by key via /cart/update.js instead)
   ============================================================ */
(function () {
  var itemsEl = document.getElementById('cart-items');
  if (!itemsEl) return;

  function changeLine(key, qty) {
    var updates = {};
    updates[key] = qty;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () { window.location.reload(); });
  }

  itemsEl.querySelectorAll('[data-inc]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-key');
      var qty = parseInt(b.getAttribute('data-current'), 10) + 1;
      changeLine(key, qty);
    });
  });
  itemsEl.querySelectorAll('[data-dec]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-key');
      var qty = parseInt(b.getAttribute('data-current'), 10) - 1;
      changeLine(key, qty);
    });
  });
  itemsEl.querySelectorAll('[data-remove]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-key');
      changeLine(key, 0);
    });
  });
})();

// Newsletter form (no backend — just confirms visually)
document.querySelectorAll('.news form').forEach(function (f) {
  f.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = f.querySelector('button');
    if (btn) btn.textContent = '¡Gracias!';
  });
});

/* ============================================================
   Panel de filtros del catálogo: Disponibilidad, Marca, Género.
   ============================================================ */
(function(){
  var openBtn = document.getElementById('cat-filter-open');
  var closeBtn = document.getElementById('cat-filter-close');
  var overlay = document.getElementById('cat-filter-overlay');
  var drawer = document.getElementById('cat-filter-drawer');
  if(!openBtn || !drawer) return;

  var cards = document.querySelectorAll('.cat-card');
  var brandSections = document.querySelectorAll('.cat-brand-section');
  var emptyMsg = document.getElementById('cat-filter-empty');
  var countEl = document.getElementById('cat-filter-count');

  var state = { stock: 'all', vendor: 'all', gender: 'all' };

  function apply(){
    var visibleCount = 0;

    cards.forEach(function(card){
      var matches =
        (state.stock === 'all' || card.getAttribute('data-stock') === state.stock) &&
        (state.vendor === 'all' || card.getAttribute('data-vendor') === state.vendor) &&
        (state.gender === 'all' || card.getAttribute('data-gender') === state.gender);
      card.style.display = matches ? '' : 'none';
      if(matches) visibleCount++;
    });

    brandSections.forEach(function(section){
      var sectionVendor = section.getAttribute('data-vendor');
      var hiddenByVendorFilter = state.vendor !== 'all' && state.vendor !== sectionVendor;
      var hasVisibleCard = !hiddenByVendorFilter && Array.prototype.some.call(
        section.querySelectorAll('.cat-card'),
        function(c){ return c.style.display !== 'none'; }
      );
      section.style.display = hasVisibleCard ? '' : 'none';
    });

    if(emptyMsg) emptyMsg.style.display = visibleCount === 0 ? 'block' : 'none';
    if(countEl) countEl.textContent = visibleCount + (visibleCount === 1 ? ' producto' : ' productos');
  }

  drawer.querySelectorAll('.cff-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var type = btn.getAttribute('data-filter-type');
      var value = btn.getAttribute('data-filter-value');
      drawer.querySelectorAll('.cff-btn[data-filter-type="' + type + '"]').forEach(function(b){
        b.classList.remove('active');
      });
      btn.classList.add('active');
      state[type] = value;
      apply();
    });
  });

  // Acordeón: cada categoría se expande/colapsa al hacer clic.
  drawer.querySelectorAll('.cfd-row').forEach(function(row){
    row.addEventListener('click', function(){
      var key = row.getAttribute('data-accordion');
      var panel = drawer.querySelector('.cfd-panel[data-panel="' + key + '"]');
      var isOpen = row.classList.contains('open');
      row.classList.toggle('open', !isOpen);
      if(panel) panel.classList.toggle('open', !isOpen);
    });
  });

  function openDrawer(){
    drawer.classList.add('open');
    if(overlay) overlay.classList.add('open');
  }
  function closeDrawer(){
    drawer.classList.remove('open');
    if(overlay) overlay.classList.remove('open');
  }

  openBtn.addEventListener('click', openDrawer);
  if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if(overlay) overlay.addEventListener('click', closeDrawer);

  apply();
})();

/* ============================================================
   Portada — widget de tamaños (3 ml / 5 ml / 10 ml)
   Solo visual/ilustrativo: cambia de grupo de precios al
   cambiar de pestaña y marca la opción seleccionada.
   ============================================================ */
(function () {
  var widget = document.querySelector('[data-hero-widget]');
  if (!widget) return;
  var tabs = widget.querySelectorAll('.size-tab');
  var groups = widget.querySelectorAll('.sizes[data-size-group]');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      var size = tab.getAttribute('data-size');
      groups.forEach(function (g) {
        g.style.display = g.getAttribute('data-size-group') === size ? '' : 'none';
      });
    });
  });

  widget.querySelectorAll('.sizes').forEach(function (group) {
    group.querySelectorAll('.size-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        group.querySelectorAll('.size-opt').forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');
      });
    });
  });
})();